import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Flex, Input, Button, Divider } from 'nallian-shared-ui/lib/components';
import createCommunityAppClientService from '../../services/communityAppClients/createCommunityAppClientService';

const AddCommunityAppClient = ({
  communityAppId,
  dispatchCreateCommunityAppClientPost,
  createCommunityAppClientFetch,
}) => {
  const { t } = useTranslation();

  const [clientId, setClientId] = useState();

  const handleChangeField = useCallback((_, { value }) => setClientId(value), [setClientId]);

  const handleSave = useCallback(
    () =>
      dispatchCreateCommunityAppClientPost(communityAppId, { clientId }, () => setClientId(''), t),
    [communityAppId, t, clientId, setClientId, dispatchCreateCommunityAppClientPost]
  );

  const handleKeyUp = useCallback(
    event => {
      if (event.key === 'Enter') handleSave();
    },
    [handleSave]
  );

  return (
    <Flex fluid direction="column">
      <Divider />
      <Flex fluid>
        <Input
          placeholder={t('addClient')}
          name="clientId"
          type="text"
          value={clientId}
          onKeyUp={handleKeyUp}
          onChange={handleChangeField}
        />
        <Button
          btnprimary
          margin="0 0 0 0.5rem"
          content={t('addClient')}
          onClick={handleSave}
          disabled={createCommunityAppClientFetch.pending}
          loading={createCommunityAppClientFetch.pending}
          icon="plus"
        />
      </Flex>
    </Flex>
  );
};

AddCommunityAppClient.propTypes = {
  communityAppId: PropTypes.string.isRequired,
  dispatchCreateCommunityAppClientPost: PropTypes.func.isRequired,
  createCommunityAppClientFetch: PropTypes.object.isRequired,
};

export default createCommunityAppClientService(AddCommunityAppClient);
